import React from 'react'
import NivoLineChartExample from './NivoLineChartExample';
import { VeltComments } from '@veltdev/react';
import './NivoChartsPage.css';
import NivoBarChartExample from './NivoBarChartExample';
import NivoPieChartExample from './NivoPieChartExample';

const tabs = {
    'line': {
        id: 'line-chart',
        label: 'Line Chart',
    },
    'bar': {
        id: 'bar-chart',
        label: 'Bar Chart',
    },
    'pie': {
        id: 'pie-chart',
        label: 'Pie Chart',
    }
}

function NivoChartsPage() {

    const [selectedTab, setSelectedTab] = React.useState(tabs.line);

    return (
        <>
            <VeltComments />
            <div className='nivo-charts-page-container'>
                <div className='nivo-charts-page-header'>Nivo Charts</div>
                <div className='nivo-charts-tabs'>
                    {
                        Object.values(tabs).map((tab) => (
                            <div
                                key={tab.id}
                                className={`nivo-charts-tab ${tab?.id === selectedTab?.id ? 'active' : ''}`}
                                onClick={() => setSelectedTab(tab)}
                            >
                                {tab.label}
                            </div>
                        ))
                    }
                </div>
                <div className='nivo-chart-container'>
                    {
                        (selectedTab?.id === tabs?.line?.id) && <NivoLineChartExample />
                    }
                    {
                        (selectedTab?.id === tabs?.bar?.id) && <NivoBarChartExample />
                    }
                    {
                        (selectedTab?.id === tabs?.pie?.id) && <NivoPieChartExample />
                    }
                </div>
            </div>
        </>
    )
}

export default NivoChartsPage;